import React from "react";
import { useState } from "react";
import Card from "./Card";
import image from "./weather-news.png";

function NavBar() {
  const [text, setText] = useState("India");

  const showData = (event) => {
    event.preventDefault();
    let e = document.getElementById("search");
    setText(e.value);
    e.value = "";
  };
  return (
    <div className="container">
      <nav className="navbar navbar-expand-lg ">
        <div className="container-fluid">
          <a className="navbar-brand" href="#">
            <img src={image} alt="" style={{ width: "10%" }} /> Weather App
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="#">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#">
                  News
                </a>
              </li>
            </ul>

            <form className="d-flex" role="search">
              <input
                id="search"
                className="form-control me-2"
                type="search"
                placeholder="Search"
                aria-label="Search"
                // onChange={storeText}
              />
              <button
                className="btn btn-outline-info"
                type="submit"
                onClick={showData}
              >
                Search
              </button>
            </form>
          </div>
        </div>
      </nav>

      <Card urlLink={text} />
    </div>
  );
}

export default NavBar;
